export const emotions = {
    ANGER: { name: 'Anger', emoji: '😡', color: '#e02929' },
    HAPPINESS: { name: 'Happiness', emoji: '😃', color: '#1f9d55' },
    SADNESS: { name: 'Sadness', emoji: '😢', color: '#2f6fed' },
    LOVE: { name: 'Love', emoji: '\u2764\uFE0F', color: '#d40c98' },
    EXCITEMENT: { name: 'Excitement', emoji: '🤩', color: '#e08e0b' },
    FRUSTRATION: { name: 'Frustration', emoji: '😤', color: '#d9541e' },
    FEAR: { name: 'Fear', emoji: '😨', color: '#7b40d4' },
    SURPRISE: { name: 'Surprise', emoji: '😮', color: '#0d9aa8' },
    DISGUST: { name: 'Disgust', emoji: '🤢', color: '#6b8e23' },
}

const getEmotion = (emotion) => {
    const emotionKey = String(emotion).trim().toUpperCase()
    return emotions[emotionKey]
}

export default getEmotion
